import { render, staticRenderFns } from "./ShozokuExpDetails.vue?vue&type=template&id=45bcb21c"
import script from "./ShozokuExpDetails.vue?vue&type=script&lang=js"
export * from "./ShozokuExpDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports